if($('.ChannelBar-stacked').length){
    var li = $('.ChannelBar-stacked li');
    var lip = $('.ChannelBar-stacked li p');

    var tl = gsap.timeline();
    tl
        .to(li, 1, {
            position: "relative",
            ease: Power3.easeOut
        }, 0.1)
        .from(lip, 0.2, {
            display: "none",
            transform: "translate(0,-10px)"
        }, '+=0.2');
    li.hover(
        function() {
            tl.timeScale(1);
            tl.play();
        },
        function() {
            tl.timeScale(4);
            tl.reverse();
        }
    )
    tl.timeScale(4);
    tl.reverse();
}